export const FINGERS = ['lp', 'lr', 'lm', 'li', 'ri', 'rm', 'rr', 'rp', 'th'];
const k = (id, base, finger, extra = {}) => ({ id, base, finger, ...extra });
const mod = (id, modifier, finger, width) => ({
    id,
    base: '',
    finger,
    width,
    modifier,
});
const SPACE_ROW = [{ ...mod('space', 'space', 'th', 6.25), base: ' ' }];
const ES_QWERTY = {
    id: 'es-qwerty',
    language: 'es',
    name: 'Español (España) QWERTY',
    rows: [
        [
            k('Backquote', 'º', 'lp', { shift: 'ª', altGr: '\\' }),
            k('Digit1', '1', 'lp', { shift: '!', altGr: '|' }),
            k('Digit2', '2', 'lr', { shift: '"', altGr: '@' }),
            k('Digit3', '3', 'lm', { shift: '·', altGr: '#' }),
            k('Digit4', '4', 'li', { shift: '$', altGr: '~' }),
            k('Digit5', '5', 'li', { shift: '%', altGr: '€' }),
            k('Digit6', '6', 'ri', { shift: '&', altGr: '¬' }),
            k('Digit7', '7', 'ri', { shift: '/' }),
            k('Digit8', '8', 'rm', { shift: '(' }),
            k('Digit9', '9', 'rr', { shift: ')' }),
            k('Digit0', '0', 'rp', { shift: '=' }),
            k('Minus', "'", 'rp', { shift: '?' }),
            k('Equal', '¡', 'rp', { shift: '¿' }),
            mod('Backspace', 'backspace', 'rp', 2),
        ],
        [
            mod('Tab', 'tab', 'lp', 1.5),
            k('KeyQ', 'q', 'lp', { shift: 'Q' }),
            k('KeyW', 'w', 'lr', { shift: 'W' }),
            k('KeyE', 'e', 'lm', { shift: 'E', altGr: '€' }),
            k('KeyR', 'r', 'li', { shift: 'R' }),
            k('KeyT', 't', 'li', { shift: 'T' }),
            k('KeyY', 'y', 'ri', { shift: 'Y' }),
            k('KeyU', 'u', 'ri', { shift: 'U' }),
            k('KeyI', 'i', 'rm', { shift: 'I' }),
            k('KeyO', 'o', 'rr', { shift: 'O' }),
            k('KeyP', 'p', 'rp', { shift: 'P' }),
            k('BracketLeft', '`', 'rp', { shift: '^', altGr: '[', dead: true }),
            k('BracketRight', '+', 'rp', { shift: '*', altGr: ']' }),
            mod('Enter', 'enter', 'rp', 1.5),
        ],
        [
            mod('CapsLock', 'caps', 'lp', 1.75),
            k('KeyA', 'a', 'lp', { shift: 'A' }),
            k('KeyS', 's', 'lr', { shift: 'S' }),
            k('KeyD', 'd', 'lm', { shift: 'D' }),
            k('KeyF', 'f', 'li', { shift: 'F', homing: true }),
            k('KeyG', 'g', 'li', { shift: 'G' }),
            k('KeyH', 'h', 'ri', { shift: 'H' }),
            k('KeyJ', 'j', 'ri', { shift: 'J', homing: true }),
            k('KeyK', 'k', 'rm', { shift: 'K' }),
            k('KeyL', 'l', 'rr', { shift: 'L' }),
            k('Semicolon', 'ñ', 'rp', { shift: 'Ñ' }),
            k('Quote', '´', 'rp', { shift: '¨', altGr: '{', dead: true }),
            k('Backslash', 'ç', 'rp', { shift: 'Ç', altGr: '}' }),
            mod('EnterLower', 'enter', 'rp', 1.25),
        ],
        [
            mod('ShiftLeft', 'shift-left', 'lp', 1.25),
            k('IntlBackslash', '<', 'lp', { shift: '>' }),
            k('KeyZ', 'z', 'lp', { shift: 'Z' }),
            k('KeyX', 'x', 'lr', { shift: 'X' }),
            k('KeyC', 'c', 'lm', { shift: 'C' }),
            k('KeyV', 'v', 'li', { shift: 'V' }),
            k('KeyB', 'b', 'li', { shift: 'B' }),
            k('KeyN', 'n', 'ri', { shift: 'N' }),
            k('KeyM', 'm', 'ri', { shift: 'M' }),
            k('Comma', ',', 'rm', { shift: ';' }),
            k('Period', '.', 'rr', { shift: ':' }),
            k('Slash', '-', 'rp', { shift: '_' }),
            mod('ShiftRight', 'shift-right', 'rp', 2.75),
        ],
        SPACE_ROW,
    ],
};
const EN_QWERTY = {
    id: 'en-qwerty',
    language: 'en',
    name: 'English (US) QWERTY',
    rows: [
        [
            k('Backquote', '`', 'lp', { shift: '~' }),
            k('Digit1', '1', 'lp', { shift: '!' }),
            k('Digit2', '2', 'lr', { shift: '@' }),
            k('Digit3', '3', 'lm', { shift: '#' }),
            k('Digit4', '4', 'li', { shift: '$' }),
            k('Digit5', '5', 'li', { shift: '%' }),
            k('Digit6', '6', 'ri', { shift: '^' }),
            k('Digit7', '7', 'ri', { shift: '&' }),
            k('Digit8', '8', 'rm', { shift: '*' }),
            k('Digit9', '9', 'rr', { shift: '(' }),
            k('Digit0', '0', 'rp', { shift: ')' }),
            k('Minus', '-', 'rp', { shift: '_' }),
            k('Equal', '=', 'rp', { shift: '+' }),
            mod('Backspace', 'backspace', 'rp', 2),
        ],
        [
            mod('Tab', 'tab', 'lp', 1.5),
            k('KeyQ', 'q', 'lp', { shift: 'Q' }),
            k('KeyW', 'w', 'lr', { shift: 'W' }),
            k('KeyE', 'e', 'lm', { shift: 'E' }),
            k('KeyR', 'r', 'li', { shift: 'R' }),
            k('KeyT', 't', 'li', { shift: 'T' }),
            k('KeyY', 'y', 'ri', { shift: 'Y' }),
            k('KeyU', 'u', 'ri', { shift: 'U' }),
            k('KeyI', 'i', 'rm', { shift: 'I' }),
            k('KeyO', 'o', 'rr', { shift: 'O' }),
            k('KeyP', 'p', 'rp', { shift: 'P' }),
            k('BracketLeft', '[', 'rp', { shift: '{' }),
            k('BracketRight', ']', 'rp', { shift: '}' }),
            k('Backslash', '\\', 'rp', { shift: '|', width: 1.5 }),
        ],
        [
            mod('CapsLock', 'caps', 'lp', 1.75),
            k('KeyA', 'a', 'lp', { shift: 'A' }),
            k('KeyS', 's', 'lr', { shift: 'S' }),
            k('KeyD', 'd', 'lm', { shift: 'D' }),
            k('KeyF', 'f', 'li', { shift: 'F', homing: true }),
            k('KeyG', 'g', 'li', { shift: 'G' }),
            k('KeyH', 'h', 'ri', { shift: 'H' }),
            k('KeyJ', 'j', 'ri', { shift: 'J', homing: true }),
            k('KeyK', 'k', 'rm', { shift: 'K' }),
            k('KeyL', 'l', 'rr', { shift: 'L' }),
            k('Semicolon', ';', 'rp', { shift: ':' }),
            k('Quote', "'", 'rp', { shift: '"' }),
            mod('Enter', 'enter', 'rp', 2.25),
        ],
        [
            mod('ShiftLeft', 'shift-left', 'lp', 2.25),
            k('KeyZ', 'z', 'lp', { shift: 'Z' }),
            k('KeyX', 'x', 'lr', { shift: 'X' }),
            k('KeyC', 'c', 'lm', { shift: 'C' }),
            k('KeyV', 'v', 'li', { shift: 'V' }),
            k('KeyB', 'b', 'li', { shift: 'B' }),
            k('KeyN', 'n', 'ri', { shift: 'N' }),
            k('KeyM', 'm', 'ri', { shift: 'M' }),
            k('Comma', ',', 'rm', { shift: '<' }),
            k('Period', '.', 'rr', { shift: '>' }),
            k('Slash', '/', 'rp', { shift: '?' }),
            mod('ShiftRight', 'shift-right', 'rp', 2.75),
        ],
        SPACE_ROW,
    ],
};
export const LAYOUTS = {
    'es-qwerty': ES_QWERTY,
    'en-qwerty': EN_QWERTY,
};
export function getLayout(id) {
    return LAYOUTS[id];
}
/** Vocales acentuadas que se escriben con tecla muerta en la distribución española. */
const ES_DEAD_COMPOSE = {
    á: { dead: '´', base: 'a' }, é: { dead: '´', base: 'e' }, í: { dead: '´', base: 'i' }, ó: { dead: '´', base: 'o' }, ú: { dead: '´', base: 'u' },
    Á: { dead: '´', base: 'A' }, É: { dead: '´', base: 'E' }, Í: { dead: '´', base: 'I' }, Ó: { dead: '´', base: 'O' }, Ú: { dead: '´', base: 'U' },
    ü: { dead: '¨', base: 'u' }, Ü: { dead: '¨', base: 'U' },
    à: { dead: '`', base: 'a' }, è: { dead: '`', base: 'e' }, ò: { dead: '`', base: 'o' },
};
const strokeCache = new Map();
function buildStrokeMap(layout) {
    const map = new Map();
    for (const row of layout.rows) {
        for (const key of row) {
            if (key.modifier && key.modifier !== 'space')
                continue;
            const add = (char, stroke) => {
                if (char && !map.has(char))
                    map.set(char, [stroke]);
            };
            add(key.base, { keyId: key.id, shift: false, altGr: false });
            add(key.shift, { keyId: key.id, shift: true, altGr: false });
            add(key.altGr, { keyId: key.id, shift: false, altGr: true });
        }
    }
    if (layout.language === 'es') {
        for (const [char, compose] of Object.entries(ES_DEAD_COMPOSE)) {
            const dead = map.get(compose.dead)?.[0];
            const base = map.get(compose.base)?.[0];
            if (dead && base)
                map.set(char, [dead, base]);
        }
    }
    return map;
}
/** Secuencia de teclas que produce `char` en la distribución dada (vacía si no existe). */
export function strokesFor(layoutId, char) {
    let map = strokeCache.get(layoutId);
    if (!map) {
        map = buildStrokeMap(getLayout(layoutId));
        strokeCache.set(layoutId, map);
    }
    return map.get(char) ?? [];
}
/** Tecla Mayús que corresponde usar (la de la mano opuesta). */
export function shiftKeyFor(layoutId, keyId) {
    const key = findKey(layoutId, keyId);
    return key && key.finger.startsWith('l') ? 'ShiftRight' : 'ShiftLeft';
}
export function findKey(layoutId, keyId) {
    for (const row of getLayout(layoutId).rows) {
        const key = row.find((candidate) => candidate.id === keyId);
        if (key)
            return key;
    }
    return undefined;
}
/** Dedo con el que se escribe un carácter (el de la última tecla de la secuencia). */
export function fingerFor(layoutId, char) {
    const strokes = strokesFor(layoutId, char);
    const last = strokes[strokes.length - 1];
    if (!last)
        return null;
    return findKey(layoutId, last.keyId)?.finger ?? null;
}
//# sourceMappingURL=layouts.js.map